import 'react';
import 'prop-types';
import '../types/props.js';
import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import selector from '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import _Button from 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import StyledIcon from '../Icon/styled.js';
import { a as Icon } from '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import Button from '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import 'reakit/Navigation';
import '../Navigation/styled.js';
import '../chunk-18be6601.js';
import Navigation from '../Navigation/index.js';
import '../chunk-5c9bbccf.js';
import 'reakit/Popover';
import '../Popover/PopoverContainer.js';
import '../Popover/styled.js';
import '../Popover/PopoverHide.js';
import '../Popover/PopoverClose.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Popover/PopoverPopover.js';
import '../Popover/PopoverShow.js';
import '../Popover/PopoverToggle.js';
import '../chunk-8dd1e1d3.js';
import 'reakit/Divider';
import '../Divider/styled.js';
import Divider from '../Divider/index.js';
import Popover from '../Popover/index.js';

var MenuItem = styled(_Button).withConfig({
  displayName: "styled__MenuItem",
  componentId: "l9b8us-0"
})(["background-color:unset;cursor:pointer;display:block;font-weight:", ";padding:", "rem ", "rem;text-align:left;width:100%;a&{color:unset;fill:unset;text-decoration:unset;&:hover{color:unset;fill:unset;}}&[disabled]{cursor:not-allowed;opacity:0.5;&{", ";}}&:not(:disabled):focus{outline:unset;background-color:", ";&{", ";}}&:not(:disabled):hover{background-color:", ";&{", ";}}&:not(:disabled):focus:active,&:not(:disabled):hover:active{background-color:", ";}", " & ", "{top:0.15em;}&{", ";}"], theme('fannypack.fontWeights.semibold'), space(1.5), space(4), theme('fannypack.Menu.Item.disabled'), palette('white600'), theme('fannypack.Menu.Item.focus'), palette('white600'), theme('fannypack.Menu.Item.hover'), palette('white700'), function (props) {
  return props.isActive && css(["background-color:", ";&&:hover,&&:focus{background-color:", ";}&{", ";}"], palette('white700'), palette('white800'), theme('fannypack.Menu.Item.active'));
}, selector(StyledIcon), theme('fannypack.Menu.Item.base'));
var MenuButton = styled(Button).withConfig({
  displayName: "styled__MenuButton",
  componentId: "l9b8us-1"
})(["&{", ";}"], theme('fannypack.Menu.Button.base'));
var MenuDivider = styled(Divider).withConfig({
  displayName: "styled__MenuDivider",
  componentId: "l9b8us-2"
})(["margin:0;width:100%;&{", ";}"], theme('fannypack.Menu.Divider.base'));
var MenuIcon = styled(Icon).withConfig({
  displayName: "styled__MenuIcon",
  componentId: "l9b8us-3"
})(["margin-right:", "rem;&{", ";}"], space(2), theme('fannypack.Menu.Item.icon'));
var MenuGroup = styled(Box).withConfig({
  displayName: "styled__MenuGroup",
  componentId: "l9b8us-4"
})(["margin:", "rem 0;width:100%;&{", ";}"], space(2), theme('fannypack.Menu.Group.base'));
var MenuGroupTitle = styled(Box).withConfig({
  displayName: "styled__MenuGroupTitle",
  componentId: "l9b8us-5"
})(["color:", ";font-size:", "rem;font-weight:", ";letter-spacing:1px;padding:", "rem ", "rem;padding-top:", "rem;text-transform:uppercase;&{", ";}"], palette('text200'), theme('fannypack.fontSizes.100'), theme('fannypack.fontWeights.semibold'), space(2), space(4), space(1), theme('fannypack.Menu.Group.title'));
var MenuPopover = styled(Popover).withConfig({
  displayName: "styled__MenuPopover",
  componentId: "l9b8us-6"
})(["padding:0px;width:200px;&{", ";}"], theme('fannypack.Menu.Popover.base'));
var Menu = styled(Navigation).withConfig({
  displayName: "styled__Menu",
  componentId: "l9b8us-7"
})(["display:flex;align-items:flex-start;", ";&{", ";}"], function (props) {
  return props.isHorizontal ? css(["flex-direction:row;& ", "{display:flex;flex-direction:row;flex-wrap:wrap;}& ", "{width:unset;}&{", ";}"], selector(MenuGroup), selector(MenuItem), theme('fannypack.Menu.horizontal')) : css(["flex-direction:column;&{", ";}"], theme('fannypack.Menu.vertical'));
}, theme('fannypack.Menu.base'));

export default Menu;
export { Menu, MenuButton, MenuDivider, MenuGroup, MenuGroupTitle, MenuIcon, MenuItem, MenuPopover };
